/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="79.95" height="95.58" viewBox="0 0 79.95 95.58" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <path d="M97.83,54.09V44.36a13.62,13.62,0,0,0-27.23,0v9.73" transform="translate(-37.5 -29.5)" fill="none" stroke="#ffb81c" strokeWidth="2.5px" strokeLinejoin="round" strokeLinecap="round"/><polygon points="69.7 94.33 78.7 90.73 78.7 29.49 69.7 25.89 1.25 25.89 1.25 94.33 69.7 94.33" fill="none" stroke="#0e497b" strokeWidth="2.5px" strokeLinejoin="round" strokeLinecap="round"/><path d="M84.36,65.81V44.36a13.62,13.62,0,0,0-27.23,0V65.81" transform="translate(-37.5 -29.5)" fill="none" stroke="#ffb81c" strokeWidth="2.5px" strokeLinejoin="round" strokeLinecap="round"/><path d="M107.2,54.52a1.25,1.25,0,0,1,1.24,1.13v67.89a1.25,1.25,0,0,1-2.5.13V55.77A1.25,1.25,0,0,1,107.2,54.52Z" transform="translate(-37.5 -29.5)" fill="#0e497b"/>
</svg>

    );
  }
}

Icon.displayName = 'PaperShoppingBagEmptyIcon';

export default Icon;
